{
  "maximum": "Máximo",
  "minimum": "Mínimo"
}
